import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { GridTableParametersService } from 'src/app/template/gridTemplate/gridTableParameters.service';
import { FromPicklistPipe } from 'src/app/shared/pipes/fromPicklistPipe.pipe';
import { FormularService } from 'src/app/Services/formular.service';
import { ErrorHandlingService } from 'src/app/Services/errorHandling.service';
import { ConfirmationWindow } from 'src/app/template/deleteTemplate/confirmationWindow.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateResourceDefinitionPipe } from 'src/app/shared/pipes/translateResourceDefinition.pipe';

@Component({
  selector: 'app-manual-request',
  templateUrl: './manual-request.component.html',
  styleUrls: ['./manual-request.component.css']
})
export class ManualRequestComponent implements OnInit {  
  @Output() public submitFormular = new EventEmitter();

  resourceDefinition;
  Picklist;

  constructor(
    private shareData: SharingDataService,
    public grid: GridTableParametersService,
    public fromPicklist: FromPicklistPipe,
    public formularService: FormularService,
    public dialog: MatDialog,
    private errorHandlingService: ErrorHandlingService,
    public translateResourceDefinition: TranslateResourceDefinitionPipe,
  ) { }

  groupName="MS_REQ_N";

  MS_REQDOC_NColumns = [
    {name: "ID",            visible: false,  enableFilter: false,  enableOrderBy: false,    export : false,   type : "text",    columnSearch : false,   fromToFilter : false,   picklistTableName : null,         function : null,               CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null},
    {name: "USERNAME",      visible: true,   enableFilter: false,  enableOrderBy: false,    export : false,   type : "text",    columnSearch : false,   fromToFilter : false,   picklistTableName : null,         function : null,               CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null},
    {name: "CONTENTTYPE",   visible: true,   enableFilter: false,  enableOrderBy: false,    export : false,   type : "text",    columnSearch : false,   fromToFilter : false,   picklistTableName : null,         function : null,               CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null},
    {name: "Delete",        visible: true,   enableFilter: false,  enableOrderBy: false,    export : false,   type : "icon",    columnSearch : false,   fromToFilter : false,   picklistTableName : null,         function : "delete",           CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [], icon: "delete", search : "", format : null},
  ]
  @ViewChild('fileInput') fileName;

  formularAction(action) {
    this[action]();
  }

  gridAction(parameters){
    this[parameters.action](parameters.element, parameters.column);
  }

  onSubmit() {
    this.submitFormular.emit();
  }

  ngOnInit(): void {
    this.shareData.currentResourceDefinition.subscribe(data => this.resourceDefinition = data);
    this.shareData.currentPicklist.subscribe(data => this.Picklist = data);
  }

  fileToUpload: File = null;
  uploadMessage;
  MS_REQDOC_N = new Array();
  MS_REQDOC_NFiles = new Array();


  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
    this.upload();
  }

  upload() {
    var maxID = 0;
    this.MS_REQDOC_N.forEach(element => {
      if(element.ID > maxID){
        maxID = element.ID;
      }
    });

    if(this.fileToUpload != null){
      var fileElement = {
        ID: maxID+1,
        USERNAME: this.fileToUpload.name,
        CONTENTTYPE: this.fileToUpload.name.match("[^\.]+$")[0],
      }

      var temporaryMS_REQDOC_N = [...this.MS_REQDOC_N];
      this.MS_REQDOC_N = null;
      this.MS_REQDOC_N = [...temporaryMS_REQDOC_N];
      this.MS_REQDOC_N.push(fileElement);
      this.MS_REQDOC_NFiles.push(this.fileToUpload);
      this.fileToUpload = null;
    }

    this.shareData.changenewRequestUploadFiles(this.MS_REQDOC_NFiles);
  }

  delete(element, column) {

    const dialogRef = this.dialog.open(ConfirmationWindow, {
      data: {
        Title : "ConfirmDeleteTitle",
        Text : "ConfirmDeleteText",
        Placeholders: [element.USERNAME],
        Actions: [{
          Text: "ConfirmYes",
          Function: "REMOVE",
        },
        {
          Text: "ConfirmNo",
        }]
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "REMOVE") {
        var temporaryMS_REQDOC_N = [...this.MS_REQDOC_N];
        this.MS_REQDOC_N = null;
        this.MS_REQDOC_N = [...temporaryMS_REQDOC_N];
        var index = this.MS_REQDOC_N.indexOf(element);
        this.MS_REQDOC_N.splice(index,1);
        this.MS_REQDOC_NFiles.splice(index,1);
        this.shareData.changenewRequestUploadFiles(this.MS_REQDOC_NFiles);
      }
    });
  }

  onInput(){
    let filename = this.fileName.nativeElement.files[0].name;
    if (filename != undefined)  {
      let fileHasBeenSelected = this.translateResourceDefinition.transform("fileHasBeenSelected", this.resourceDefinition, 'KEY_NAME', 'LONG_TEXT', "Common");
      fileHasBeenSelected = fileHasBeenSelected.replace("{0}",filename);
      
      this.errorHandlingService.showInfo('', fileHasBeenSelected)
    }
  }
}
